export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary-600 via-primary-700 to-primary-900 p-8 md:p-12">
          <div className="absolute top-0 right-0 w-64 h-64 bg-accent-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-accent-500/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

          <div className="relative flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">联系我们</h2>
              <p className="text-sm md:text-base text-primary-100/80 leading-relaxed max-w-md">
                有好的电影推荐？想加入我们？欢迎通过以下方式与被窝影院团队取得联系。
                无论是资源投稿、合作洽谈还是意见反馈，我们都会认真倾听。
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="mailto:contact@beiwocinema.com"
                className="px-6 py-3 rounded-lg bg-background-50 hover:bg-background-100 text-primary-700 font-medium text-sm whitespace-nowrap flex items-center justify-center gap-2 transition-all cursor-pointer"
              >
                <i className="ri-mail-line text-lg"></i>
                邮件投稿
              </a>
              <a
                href="#about"
                className="px-6 py-3 rounded-lg border border-background-50/30 hover:border-background-50/60 text-background-50 font-medium text-sm whitespace-nowrap flex items-center justify-center gap-2 transition-all cursor-pointer"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}